import React from 'react';
import { Link } from 'react-router-dom';
import classes from './unauthorized.module.scss';

export const Unauthorized = () => {

    return (
        <div className={classes.container}>
            <h1>משהו בלתי צפוי קרה!</h1>
            <Link to="/">רענן מערכת ונסה שנית</Link>
        </div>
    );
};
